import { useSearchParams } from 'react-router-dom';
import { clsx } from 'clsx';

const OPTIONS = [
  { value: '90d', label: '90 Days' },
  { value: '6m', label: '6 Months' },
  { value: '1y', label: '1 Year' },
  { value: 'all', label: 'All Time' },
];

export function CohortLookbackToggle() {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get('cohort_lookback') ?? 'all';

  function set(v: string) {
    const next = new URLSearchParams(searchParams);
    next.set('cohort_lookback', v);
    setSearchParams(next, { replace: true });
  }

  return (
    <div className="flex items-center gap-1">
      <span className="text-[10px] font-mono uppercase text-slate-400 mr-1">
        Customer cohort lookback
      </span>
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => set(o.value)}
          className={clsx(
            'rounded-full border px-3 py-1 text-xs',
            value === o.value
              ? 'border-teal-500 bg-teal-50 text-teal-700'
              : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
